<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="11" @click="toNewRouter('park-over-view')" v-if="permissionCodes.indexOf('004028000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="15" v-if="permissionCodes.indexOf('004029000') !== -1 || permissionCodes.indexOf('004025000') !== -1|| permissionCodes.indexOf('004031000') !== -1 || permissionCodes.indexOf('004030000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-tingchechang1"></i>
          <span>车位管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="15-4" @click="toNewRouter('parking-lot-area')" v-if="permissionCodes.indexOf('004029000') !== -1">车位区域</el-menu-item>
          <el-menu-item index="15-1" @click="toNewRouter('parking-lot-manage')" v-if="permissionCodes.indexOf('004025000') !== -1">车位信息</el-menu-item>
          <el-menu-item index="15-2" @click="toNewRouter('parking-rent')" v-if="permissionCodes.indexOf('004030000') !== -1">车位租赁</el-menu-item>
          <el-menu-item index="15-3" @click="toNewRouter('parking-fee-rule')" v-if="permissionCodes.indexOf('004031000') !== -1">车位收费规则</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="1" v-if="permissionCodes.indexOf('004001000') !== -1 || permissionCodes.indexOf('004002000') !== -1 || permissionCodes.indexOf('004003000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-shebeiguanli1"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="toNewRouter('parking-device-management')" v-if="permissionCodes.indexOf('004001000') !== -1">出入口相机</el-menu-item>
          <el-menu-item index="1-3" @click="toNewRouter('ent-and-exit-manage')" v-if="permissionCodes.indexOf('004002000') !== -1">出入口管理</el-menu-item>
          <el-menu-item index="1-2" @click="toNewRouter('display-manage')" v-if="permissionCodes.indexOf('004003000') !== -1">显示屏管理</el-menu-item>
          <el-menu-item index="1-4" @click="toNewRouter('guidance-screen-manage')" v-if="permissionCodes.indexOf('') !== -1">诱导屏管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="3" @click="toNewRouter('sentry-box-manage')" v-if="permissionCodes.indexOf('004004000') !== -1">
        <i class="el-icon-damai-jiaose"></i>
        <span slot="title">岗亭账号管理</span>
      </el-menu-item>
      <el-submenu index="4" v-if="permissionCodes.indexOf('004005000') !== -1 || permissionCodes.indexOf('004006000') !== -1 || permissionCodes.indexOf('004007000') !== -1 || permissionCodes.indexOf('004008000') !== -1 || permissionCodes.indexOf('004009000') !== -1">
        <template slot="title">
          <i class="el-icon-damai--tingche"></i>
          <span>车辆管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="4-1" @click="toNewRouter('authorization-management')" v-if="permissionCodes.indexOf('004005000') !== -1">车辆信息</el-menu-item>
          <el-menu-item index="4-2" @click="toNewRouter('black-list-vehicles-manage')" v-if="permissionCodes.indexOf('004006000') !== -1">黑名单</el-menu-item>
          <el-menu-item index="4-3" @click="toNewRouter('white-list-vehicles-manage')" v-if="permissionCodes.indexOf('004007000') !== -1">白名单</el-menu-item>
          <el-menu-item index="4-5" @click="toNewRouter('monthly-vehicle')" v-if="permissionCodes.indexOf('004008000') !== -1">包月车辆</el-menu-item>
          <el-menu-item index="4-4" @click="toNewRouter('vehicles-on-site')" v-if="permissionCodes.indexOf('004009000') !== -1">在场车辆</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="14" v-if="permissionCodes.indexOf('004010000') !== -1 || permissionCodes.indexOf('004011000') !== -1 ">
        <template slot="title">
          <i class="el-icon-damai-jiaofeijilu"></i>
          <span>账单管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="14-1" @click="toNewRouter('parking-bill')" v-if="permissionCodes.indexOf('004010000') !== -1">停车账单</el-menu-item>
          <el-menu-item index="14-2" @click="toNewRouter('parking-month-bill')" v-if="permissionCodes.indexOf('004011000') !== -1">包月账单</el-menu-item>
          <el-menu-item index="14-3" @click="toNewRouter('parking-coupon-bill')" v-if="permissionCodes.indexOf('004033000') !== -1">优惠券账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="8" v-if="permissionCodes.indexOf('004012000') !== -1 || permissionCodes.indexOf('004027000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-jiaofeijilu1"></i>
          <span>收费记录</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="8-1" @click="toNewRouter('monthly-payment')" v-if="permissionCodes.indexOf('004012000') !== -1">包月缴费</el-menu-item>
          <el-menu-item index="8-2" @click="toNewRouter('temporary-stop')" v-if="permissionCodes.indexOf('004027000') !== -1">临停收费</el-menu-item>
          <el-menu-item index="8-3" @click="toNewRouter('coupon-payment')" v-if="permissionCodes.indexOf('004035000') !== -1">优惠券收费</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="5" @click="toNewRouter('enter-record')" v-if="permissionCodes.indexOf('004013000') !== -1">
        <i class="el-icon-damai-jinchukoudengji"></i>
        <span slot="title">进出记录</span>
      </el-menu-item>
      <el-menu-item index="18" @click="toNewRouter('LPR-record')" v-if="permissionCodes.indexOf('004039000') !== -1">
        <i class="el-icon-damai-jinchukoudengji"></i>
        <span slot="title">车牌识别记录</span>
      </el-menu-item>
      <el-menu-item index="16" @click="toNewRouter('free-code-record')" v-if="permissionCodes.indexOf('004032000') !== -1">
        <i class="el-icon-damai-ic_mianfeimashiyongjilu"></i>
        <span slot="title">免费码使用记录</span>
      </el-menu-item>
      <el-submenu index="7" v-if="permissionCodes.indexOf('004014000') !== -1 || permissionCodes.indexOf('004015000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-jine"></i>
          <span>收费规则</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="7-2" @click="toNewRouter('parking-month-config-center')" v-if="permissionCodes.indexOf('004014000') !== -1">包月停车费</el-menu-item>
          <el-menu-item index="7-3" @click="toNewRouter('parking-temporary-config-center')" v-if="permissionCodes.indexOf('004015000') !== -1">临时停车费</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="12" v-if="permissionCodes.indexOf('004016000') !== -1 || permissionCodes.indexOf('004017000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-yajin"></i>
          <span>收款账户</span>
        </template>
        <el-menu-item-group>
<!--          <el-menu-item index="12-1" @click="toNewRouter('parking-wx-account-manage')" v-if="permissionCodes.indexOf('004016000') !== -1">微信收款账户</el-menu-item>-->
          <el-menu-item index="12-2" @click="toNewRouter('parking-ali-account-manage')" v-if="permissionCodes.indexOf('004017000') !== -1">支付宝收款账户</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="6" v-if="permissionCodes.indexOf('004018000') !== -1 || permissionCodes.indexOf('004019000') !== -1 || permissionCodes.indexOf('004020000') !== -1 || permissionCodes.indexOf('004021000') !== -1 || permissionCodes.indexOf('004022000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-youhuiquan"></i>
          <span>优惠券</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="6-1" @click="toNewRouter('coupon-put-on-the-shelves')" v-if="permissionCodes.indexOf('004018000') !== -1">上架</el-menu-item>
          <el-menu-item index="6-2" @click="toNewRouter('coupon-sell')" v-if="permissionCodes.indexOf('004019000') !== -1">出售</el-menu-item>
          <el-menu-item index="6-3" @click="toNewRouter('coupon-refund')" v-if="permissionCodes.indexOf('004020000') !== -1">退券</el-menu-item>
          <el-menu-item index="6-4" @click="toNewRouter('coupon-usage-record')" v-if="permissionCodes.indexOf('004021000') !== -1">使用记录</el-menu-item>
          <el-menu-item index="6-5" @click="toNewRouter('coupon-merchant-statistics')" v-if="permissionCodes.indexOf('004022000') !== -1">商户统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="13" v-if="permissionCodes.indexOf('004023000') !== -1 || permissionCodes.indexOf('004026000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-peizhi"></i>
          <span>其他配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="13-1" @click="toNewRouter('free-code-author')" v-if="permissionCodes.indexOf('004023000') !== -1">免费码授权</el-menu-item>
          <el-menu-item index="13-2" @click="toNewRouter('yard-configuration')" v-if="permissionCodes.indexOf('004026000') !== -1">车场配置</el-menu-item>
          <el-menu-item index="13-3" @click="toNewRouter('inner-configuration')" v-if="permissionCodes.indexOf('004026000') !== -1">场中场配置</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="17" v-if="permissionCodes.indexOf('004036000') !== -1 || permissionCodes.indexOf('004037000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_mianfeimashouquanrenshenpi"></i>
          <span>值班人员</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="17-1" @click="toNewRouter('personnel-on-duty-classes-manage')" v-if="permissionCodes.indexOf('004036000') !== -1">班次管理</el-menu-item>
          <el-menu-item index="17-2" @click="toNewRouter('personnel-on-duty-schedule-manage')" v-if="permissionCodes.indexOf('004037000') !== -1">排班管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="9" @click="toNewRouter('device-status-log')" v-if="permissionCodes.indexOf('004024000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>

      <el-menu-item index="10" @click="toNewRouter('parking-service-log')" v-if="permissionCodes.indexOf('004006000') !== -1">
        <i class="el-icon-setting"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
<!--
      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  "1-1": [
    "parking-device-management",
    "parking-device-add",
    "parking-device-current",
    "parking-device-modify"
  ],
  "1-2": ["display-manage", "display-add", "display-modify"],
  "1-3": ["ent-and-exit-manage"],
  "1-4": ["guidance-screen-manage", "guidance-screen-add", "guidance-screen-modify"],
  3: ["sentry-box-manage", "sentry-box-add", "sentry-box-modify"],
  "4-1": ["authorization-management", "authorization-add"],
  "4-2": [
    "black-list-vehicles-manage",
    "black-list-vehicles-add",
    "black-list-vehicles-modify"
  ],
  "4-3": [
    "white-list-vehicles-manage",
    "white-list-vehicles-add",
    "white-list-vehicles-modify"
  ],
  "4-4": [
    "vehicles-on-site",
    "vehicles-on-site-add",
    "vehicles-on-site-modify"
  ],
  "4-5": [
    "monthly-vehicle",
    "monthly-vehicle-add",
    "monthly-vehicle-modify",
    "monthly-vehicle-refund",
    "monthly-vehicle-renew"
  ],
  5: "enter-record",
  "6-1": [
    "coupon-put-on-the-shelves",
    "coupon-put-on-the-shelves-add",
    "coupon-put-on-the-shelves-modify"
  ],
  "6-2": ["coupon-sell", "coupon-sell-add"],
  "6-3": ["coupon-refund", "coupon-refund-add"],
  "6-4": ["coupon-usage-record"],
  "6-5": ["coupon-merchant-statistics"],
  // '5': ['amount-allocation', 'amount-add', 'amount-modify'],
  "7-2": ["parking-month-config-center", "parking-month-config-modify"],
  "7-3": ["parking-temporary-config-center", "parking-temporary-config-modify"],
  // '6': 'monthly-payment',
  "8-1": "monthly-payment",
  "8-2": "temporary-stop",
  "8-3": "coupon-payment",
  9: "device-status-log",
  10: "parking-service-log",
  11: "park-over-view",
  "12-1": [
    "parking-wx-account-manage",
    "parking-wx-account-add",
    "parking-wx-account-modify"
  ],
  "12-2": [
    "parking-ali-account-manage",
    "parking-ali-account-add",
    "parking-ali-account-modify"
  ],
  "13-1": [
    "free-code-author",
    "free-code-author-add",
    "free-code-author-modify"
  ],
  "13-2": ["yard-configuration"],
  "13-3": ["inner-configuration"],
  // 14: ["parking-bill", "parking-month-bill"],
  "14-1": ["parking-bill"],
  "14-2": ["parking-month-bill"],
  '14-3': ['parking-coupon-bill'],
  "15-1": [
    "parking-lot-manage",
    "parking-lot-add-one",
    "parking-lot-add-many",
    "parking-lot-modify"
  ],
  "15-2": ["parking-rent", "parking-rent-add"],
  "15-3": [
    "parking-fee-rule",
    "parking-fee-rule-add",
    "parking-fee-rule-modify"
  ],
  "15-4": [
    "parking-lot-area",
    "parking-lot-area-add",
    "parking-lot-area-modify"
  ],
  '17-1': ['personnel-on-duty-classes-manage', 'personnel-on-duty-classes-add', 'personnel-on-duty-classes-modify'],
  '17-2': ['personnel-on-duty-schedule-manage', 'personnel-on-duty-schedule-add', 'personnel-on-duty-schedule-modify'],
  16: "free-code-record",
  18: "LPR-record"
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      accountName: "",
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.accountName = bus.global.accountName;
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingServiceNav.vue